import React, { useContext, useEffect, useState } from 'react';

import { IconLibrary } from  '@/interfaces/IconLibrary';
import { AudienceModalState } from  '@/interfaces/ContentAudienceModal';

import { ContentAudienceContext } from './ContentAudienceContext';

import Loading from '../global/LoadingDots';
import AudienceModal from './ContentAudienceModal';
import Icon from '../icons/Icons';

import '../../../css/content/contentAudience/contentaudience.scss';



const ContentAudience = ({contentIsArchived}:{contentIsArchived: boolean}) => {
    const [audienceModalIsOpen, setAudienceModalIsOpen] = useState<boolean>(false)
    const [initalAudienceState, setInitialAudienceState] = useState<AudienceModalState>();
    const { isEditor, audienceCounts, contentId, audienceCountsLoading, disableModal} = useContext(ContentAudienceContext)

    useEffect(() => {
        setAudienceModalIsOpen(false);
    }, [disableModal])

    useEffect(() => {
        if(!audienceModalIsOpen) {
            setInitialAudienceState(undefined);
        }
    },[audienceModalIsOpen])

    function openModal(audienceState: AudienceModalState) {
        setAudienceModalIsOpen(true);
        setInitialAudienceState(audienceState)
    }

    if(!Number(contentId) || contentIsArchived) {
        return <section className='content-audience-wrapper disabled' data-testid="audience-wrapper"/>
    }

    return <section className='content-audience-wrapper'>
        <button className='view-audience-button grey-bg' type="button" onClick={() => openModal(AudienceModalState.TotalAudience)} aria-label={audienceCounts.audienceCount === 1 ? 'view 1 audience member' : `View all ${audienceCounts.audienceCount} audience members`}>
            <Icon sizeInPx={'14'} color={'var(--thriveCMSTextEmphasisColor)'} iconName={IconLibrary.USERS}></Icon>
            {audienceCountsLoading
                ? <Loading styleOveride={{background: 'var(--thriveCMSTextEmphasisColor)'}}/>
                :<>
                    <span className='audience-counts-button-text groups'>
                    {audienceCounts.everyoneHasAccess ? 'Everyone' : `${audienceCounts.groupCount} Groups`  }
                    </span>
                    {!audienceCounts.everyoneHasAccess &&
                        <span className='audience-counts-button-text users'>({audienceCounts.audienceCount} Users)</span>
                    }
                </>
            }
        </button>

        {isEditor && 
            <button type="button" className='view-audience-button' onClick={() => openModal(AudienceModalState.EditAudience)} >Edit Audience</button>
        }
        
        <AudienceModal isOpen={audienceModalIsOpen} toggleOpen={setAudienceModalIsOpen} initalAudienceState={initalAudienceState}/>
    </section>
}

export default ContentAudience;

